
import React from 'react'
import { Link } from 'react-router-dom'
import History from '../../Helpers/History'

import { connect } from 'react-redux'
import SessionActions from '../../Redux/Actions/SessionActions'
import useTranslation from '../../Hooks/UseTranslation'
import AuthLayout from '../../Layouts/AuthLayout/AuthLayout'

import '../LoginPage/LoginPage.scss'
import './ConfirmPage.scss'

const mapStateToProps = (state: any) => {

    return {
        confirmStatus: state.SessionReducer.confirmStatus,
    }
}

const mapDispatchToProps = (dispatch: any) => {

    return{
        doConfirm(token: string) {

            dispatch(SessionActions.confirmAction({ token }))
        }
    }
}

const ConfirmPage = (props: any) => {

    const { t } = useTranslation()

    const token = new URLSearchParams(props.location.search).get('token')

    if (props.confirmStatus === 'none' && token) {

        props.doConfirm(token)
    }

    if (props.confirmStatus === 'confirm_ended') {

        History.push('/login?confirmed')
        return null
    }

    const isError = !token || !['none', 'confirm_started', 'confirm_ended'].includes(props.confirmStatus)

    return (
        <AuthLayout className="pl4-auth-layout--login pl4-auth-layout--confirm">
            <main className="pl4-login-page pl4-confirm-page">
                <section className="pl4-login-showcase pl4-confirm-showcase" aria-hidden="true">
                    <div className="pl4-login-showcase__brand">
                        <img src="/svg-icons/logo-icon.svg" alt="" />
                        <strong>PL<span>4</span>NNER</strong>
                    </div>

                    <div className="pl4-confirm-showcase__visual">
                        <span><i className="far fa-envelope" /></span>
                        <div>
                            <small>{t('CONFIRM_PAGE:Eyebrow')}</small>
                            <strong>{t('CONFIRM_PAGE:ShowcaseTitle')}</strong>
                        </div>
                        <div className="pl4-confirm-showcase__path">
                            <i className="fas fa-user" />
                            <span />
                            <i className="fas fa-envelope-open-text" />
                            <span />
                            <i className="fas fa-check" />
                        </div>
                    </div>
                </section>

                <section className="pl4-login-panel pl4-confirm-panel">
                    <div className="pl4-confirm-card">
                        <img className="pl4-login-form__logo" src="/images/logo.svg" alt="PL4NNER" />
                        <span className={`pl4-confirm-card__icon ${isError ? 'has-error' : ''}`}>
                            <i className={isError ? 'fas fa-exclamation' : 'fas fa-check'} />
                        </span>
                        <span className="pl4-confirm-card__eyebrow">
                            {t(isError ? 'CONFIRM_PAGE:ErrorEyebrow' : 'CONFIRM_PAGE:Eyebrow')}
                        </span>
                        <h1>{t(isError ? 'CONFIRM_PAGE:ErrorTitle' : 'CONFIRM_PAGE:Title')}</h1>
                        <p>{t(isError ? 'CONFIRM_PAGE:ErrorDescription' : 'CONFIRM_PAGE:Loading')}</p>

                        {isError ? (
                            <Link className="pl4-btn pl4-btn-primary pl4-confirm-card__button" to="/login">
                                {t('CONFIRM_PAGE:LoginButton')}
                            </Link>
                        ) : (
                            <span className="pl4-confirm-card__progress" aria-hidden="true"><i /></span>
                        )}
                    </div>
                </section>
            </main>
        </AuthLayout>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPage)
